var map = {
	"./checkmark.png": 165,
	"./home-sample-1.png": 166,
	"./home-sample-2.png": 167,
	"./home.png": 168,
	"./logo.png": 95,
	"./sdg-goals.png": 97,
	"./search-sample-1.png": 169,
	"./search-sample-2.png": 170,
	"./search-sample-3.png": 171,
	"./search-sample-4.png": 172,
	"./search-sample-5.png": 173,
	"./sia-climate.png": 174,
	"./sia-disadv-poor.png": 175,
	"./sia-edu-learn.png": 176,
	"./sia-env.png": 177,
	"./sia-equ-div-incl.png": 178,
	"./sia-health-wellness.png": 179,
	"./sia-new-displaced.png": 180,
	"./sia-support-socass.png": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;